const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/brand/bka-logo.png`;
const LOGO_SRC_TRANSPARENT = `${process.env.PUBLIC_URL || ""}/brand/bka-logo-transparent.png`;
const MARK_SRC = `${process.env.PUBLIC_URL || ""}/brand/bka-mark.png`;

export function BkaLogo({ className = "h-11", tone = "light" }) {
  const src = tone === "dark" ? LOGO_SRC_TRANSPARENT : LOGO_SRC;
  return <img src={src} alt="Bahamas Kidney Association" className={`${className} w-auto shrink-0`} />;
}

/**
 * Horizontal lockup: official emblem plus a typeset wordmark so the name has
 * proper breathing room instead of the cramped flattened PNG.
 */
export function BkaWordmark({ tone = "light", compact = false }) {
  const dark = tone === "dark";
  return (
    <span className={`flex items-center ${compact ? "gap-2.5" : "gap-3.5"}`}>
        <span aria-hidden="true" className={`flex items-center ${compact ? "h-10" : "h-11 sm:h-12 xl:h-11 2xl:h-[54px]"}`}>
          <img src={MARK_SRC} alt="" className="h-full w-auto shrink-0" />
        </span>
      <span className="sr-only">Bahamas Kidney Association</span>
      <span aria-hidden="true" className="flex flex-col justify-center whitespace-nowrap leading-none">
        <span
          className={`font-display font-black uppercase tracking-[0.015em] ${
            compact ? "text-lg" : "text-base sm:text-2xl xl:text-xl 2xl:text-[26px]"
          } ${dark ? "text-white" : "text-bka-emeraldDark"}`}
        >
          Bahamas
        </span>
        <span
          className={`mt-[3px] font-display font-bold uppercase tracking-[0.1em] ${
            compact ? "text-[10px]" : "text-[9px] sm:text-[11px] lg:text-[12px]"
          } ${dark ? "text-white/85" : "text-bka-emerald"}`}
        >
          Kidney Association
        </span>
        {!compact && (
          <span className={`mt-[5px] hidden text-[9px] font-semibold tracking-[0.04em] sm:block sm:text-[10px] ${dark ? "text-bka-orangeLight" : "text-bka-orangeDark"}`}>
            A Healthier People. A Stronger Bahamas.
          </span>
        )}
      </span>
    </span>
  );
}
